import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../../../global/Button';
import {
  RECYCLING_PRODUCT_ITEMS_NOT_ALLOWED,
} from '../../../../utils/tbbRegistration';
import Dialog from '../../../../global/Mui/Dialog';

import './NotAllowedDevices.scss';

const NotAllowedDevices = ({
  open,
  onClose,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
  >
    <div className="NotAllowedDevices">
      <div className="NotAllowedDevices__title">
        ITEMS NOT ALLOWED
      </div>
      <div className="NotAllowedDevices__content">
        {
            RECYCLING_PRODUCT_ITEMS_NOT_ALLOWED.map((item) => (
              <div key={item} className="NotAllowedDevices__content__item">
                {item}
              </div>
            ))
          }
      </div>
      <Button
        type={BUTTON_TYPE.QUATERNARY}
        size={BUTTON_SIZE.LARGE}
        onClick={onClose}
      >
        close
      </Button>
    </div>
  </Dialog>
);

export default NotAllowedDevices;
